<template>
  <div class="layout-segment">
    <template v-if="getDomainType('travelone', 'skione')">
      <T1ATabs tabLabelType="h4">
        <T1ATabsContent
          key="0"
          data-tab="0"
          :title="tabItems[0].tytul"
          renderContent
        >
          <div class="top-offers-wrapper">
            <T1TopOffersPlaceholder v-if="oferty0.length == 0" />
            <splide v-else :slides="oferty0" :options="options">
              <splide-slide v-for="(item, idx) in oferty0" :key="idx">
                <div class="p-8 h-100">
                  <template v-if="idx < oferty0.length - 1">
                    <T1TopOfferCard :oferta="getOferty0Items(idx)" />
                  </template>
                  <template v-else>
                    <T1ExtraCard
                      :imageName="tabItems[0].grafika"
                      :offersUrl="tabItems[0].link"
                      :textColor="tabItems[0].textcolor"
                    >
                      <template v-slot:ctaText>
                        <span v-html="tabItems[0].text" />
                      </template>
                      <template v-slot:buttonText>
                        {{ tabItems[0].buttontext }}
                      </template>
                    </T1ExtraCard>
                  </template>
                </div>
              </splide-slide>
            </splide>
          </div>
        </T1ATabsContent>
        <T1ATabsContent key="1" data-tab="1" :title="tabItems[1].tytul">
          <div class="top-offers-wrapper">
            <splide :slides="oferty1" :options="options">
              <splide-slide v-for="(item, idx) in oferty1" :key="idx">
                <div class="p-8 h-100">
                  <template v-if="idx < oferty1.length - 1">
                    <T1TopOfferCard :oferta="getOferty1Items(idx)" />
                  </template>
                  <template v-else>
                    <T1ExtraCard
                      :imageName="tabItems[1].grafika"
                      :offersUrl="tabItems[1].link"
                      :textColor="tabItems[1].textcolor"
                    >
                      <template v-slot:ctaText>
                        <span v-html="tabItems[1].text" />
                      </template>
                      <template v-slot:buttonText>
                        {{ tabItems[1].buttontext }}
                      </template>
                    </T1ExtraCard>
                  </template>
                </div>
              </splide-slide>
            </splide>
          </div>
        </T1ATabsContent>
        <T1ATabsContent key="2" data-tab="2" :title="tabItems[2].tytul">
          <div class="top-offers-wrapper">
            <splide :slides="oferty2" :options="options">
              <splide-slide v-for="(item, idx) in oferty2" :key="idx">
                <div class="p-8 h-100">
                  <template v-if="idx < oferty2.length - 1">
                    <T1TopOfferCard :oferta="getOferty2Items(idx)" />
                  </template>
                  <template v-else>
                    <T1ExtraCard
                      :imageName="tabItems[2].grafika"
                      :offersUrl="tabItems[2].link"
                      :textColor="tabItems[2].textcolor"
                    >
                      <template v-slot:ctaText>
                        <span v-html="tabItems[2].text" />
                      </template>
                      <template v-slot:buttonText>
                        {{ tabItems[2].buttontext }}
                      </template>
                    </T1ExtraCard>
                  </template>
                </div>
              </splide-slide>
            </splide>
          </div>
        </T1ATabsContent>
        <T1ATabsContent key="3" data-tab="3" :title="tabItems[3].tytul">
          <div class="top-offers-wrapper">
            <splide :slides="oferty3" :options="options">
              <splide-slide v-for="(item, idx) in oferty3" :key="idx">
                <div class="p-8 h-100">
                  <template v-if="idx < oferty3.length - 1">
                    <T1TopOfferCard :oferta="getOferty3Items(idx)" />
                  </template>
                  <template v-else>
                    <T1ExtraCard
                      :imageName="tabItems[3].grafika"
                      :offersUrl="tabItems[3].link"
                      :textColor="tabItems[3].textcolor"
                    >
                      <template v-slot:ctaText>
                        <span v-html="tabItems[3].text" />
                      </template>
                      <template v-slot:buttonText>
                        {{ tabItems[3].buttontext }}
                      </template>
                    </T1ExtraCard>
                  </template>
                </div>
              </splide-slide>
            </splide>
          </div>
        </T1ATabsContent>
      </T1ATabs>
    </template>
    <template v-else>
      <h2 class="font-22 mb-16">
        {{ getMainRegionName() }} - wczasy i wycieczki
      </h2>
      <div class="top-offers-wrapper">
        <T1TopOffersPlaceholder v-if="oferty.length == 0" />
        <splide v-else :slides="oferty" :options="options">
          <splide-slide v-for="(item, idx) in oferty" :key="idx">
            <div class="p-8 h-100">
              <T1TopOfferCard :oferta="getOfertyItems(idx)" />
            </div>
          </splide-slide>
        </splide>
      </div>
    </template>
  </div>
</template>

<script>
import T1ATabs from "./T1Tabs/T1ATabs";
import T1ATabsContent from "./T1Tabs/T1ATabsContent";

import axios from "axios";
import T1TopOffersPlaceholder from "./T1Placeholders/T1TopOffersPlaceholder";
import T1TopOfferCard from "./T1OfferCards/T1TopOfferCard";
import T1ExtraCard from "./T1OfferCards/T1ExtraCard";
import { frontlinki } from "./frontlinki.js";
import { fronttabs } from "./fronttabs.js";
import * as CONFIG from "./config.js";
import { domainTypeMixin } from "@/mixins/domainTypeMixin";

axios.defaults.withCredentials = false;

export default {
  mixins: [domainTypeMixin],
  props: {
    locid: String,
  },
  data: () => ({
    url: "/getoferty.json",
    dparams: frontlinki.items[0].link.split("?").pop(),
    dparams1: fronttabs.items[0].link.split("?").pop(),
    dparams2: fronttabs.items[1].link.split("?").pop(),
    dparams3: fronttabs.items[2].link.split("?").pop(),
    dparams4: fronttabs.items[3].link.split("?").pop(),
    oferty: [],
    oferty0: [],
    oferty1: [],
    oferty2: [],
    oferty3: [],
    items: frontlinki.items,
    tabItems: fronttabs.items,
    options: {
      perMove: 1,
      perPage: 4,
      breakpoints: {
        991: {
          perPage: 3,
        },
        767: {
          perPage: 2,
        },
        479: {
          perPage: 1,
        },
      },
      gap: "8px",
    },
  }),
  methods: {
    getOfertyCustom(which) {
      var params = this.dparams;
      if (which == 0) {
        params = this.dparams1;
      } else if (which == 1) {
        params = this.dparams2;
      } else if (which == 2) {
        params = this.dparams3;
      } else if (which == 3) {
        params = this.dparams4;
      }
      return axios
        .get(CONFIG.API_URL + this.url + "?" + params + this.getLocid(), null, {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Accept: "application/json",
          },
        })
        .then((response) => {
          return response.data;
        })
        .catch((e) => {
          alert("ERROR" + e);
        });
    },
    getOferty() {
      return axios
        .get(
          CONFIG.API_URL + this.url + "?" + this.dparams + this.getLocid(),
          null,
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
              Accept: "application/json",
            },
          }
        )
        .then((response) => {
          /*alert("DATA:" + response.data);
            alert("STATUS:" + response.status);
            alert("DATA ITEMS:" + JSON.stringify(response.data));*/
          return response.data;
        })
        .catch((e) => {
          alert("ERROR" + e);
        });
    },
    getOfertyItems(i) {
      return this.oferty[i];
    },
    getOferty0Items(i) {
      return this.oferty0[i];
    },
    getOferty1Items(i) {
      return this.oferty1[i];
    },
    getOferty2Items(i) {
      return this.oferty2[i];
    },
    getOferty3Items(i) {
      return this.oferty3[i];
    },
    getMainRegionName() {
      return CONFIG.panstwo_nazwapl;
    },
    getLocid() {
      if (this.locid != null && this.locid != "") {
        return "&locid=" + this.locid;
      } else {
        return "";
      }
    },
  },
  mounted() { 
    var that = this;
    this.getOferty().then((data) => {
      //alert('OFERTY:' + JSON.stringify(data.page.response));
      this.oferty = data.page.response;
    })
    .catch((e) => {
    	that.oferty = [];
    });
    this.getOfertyCustom(0).then((data) => {
      this.oferty0 = data.page.response;
      this.oferty0.push({ extraItem: true });
    })
    .catch((e) => {
    	that.oferty0 = [];
    });
    this.getOfertyCustom(1).then((data) => {
      this.oferty1 = data.page.response;
      this.oferty1.push({ extraItem: true });
    })
    .catch((e) => {
    	that.oferty1 = [];
    });
    this.getOfertyCustom(2).then((data) => {
      this.oferty2 = data.page.response;
      this.oferty2.push({ extraItem: true });
    })
    .catch((e) => {
    	that.oferty2 = [];
    });
    this.getOfertyCustom(3).then((data) => {
      this.oferty3 = data.page.response;
      this.oferty3.push({ extraItem: true });
    })
    .catch((e) => {
    	that.oferty3 = [];
    });
  },
  components: {
    T1TopOffersPlaceholder,
    T1TopOfferCard,
    T1ExtraCard,
    T1ATabs,
    T1ATabsContent,
  },
};
</script>

<style lang="scss" scoped>
::v-deep .top-offers-wrapper {
  position: relative;
  margin-left: -8px;
  margin-right: -8px;

  .splide {
    &__pagination {
      bottom: -24px;
    }

    &__pagination__page {
      margin: 4px;

      &.is-active {
        background-color: $blue-light;
        opacity: 1;
        transform: none;
      }
    }

    &__arrow {
      background-color: #fff;
      opacity: 0.85;
      width: 2.25em;
      height: 2.5em;
      top: 96px;

      &:hover {
        opacity: 1;
      }

      &--prev {
        border-radius: 0 2.5em 2.5em 0;
        left: 0;
      }

      &--next {
        border-radius: 2.5em 0 0 2.5em;
        right: 0;
      }

      svg {
        fill: $blue-dark;
      }

      &:disabled {
        display: none;
      }
    }
  }
}
</style>
